module.exports = __webpack_public_path__ + "static/media/arrow-left-light.212ead34.svg";